"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MultiIntermediaryEquity = exports.DEFAULT_BASE_PRICE_TYPE = exports.FutureAccountType = void 0;
const Triggers_1 = require("./../interface/Triggers");
const trade_utils_lib_1 = require("trade_utils_lib");
exports.FutureAccountType = trade_utils_lib_1.AccountTradeType.trader;
exports.DEFAULT_BASE_PRICE_TYPE = Triggers_1.TriggerPriceType.LAST_PRICE;
/** 中介币 */
exports.MultiIntermediaryEquity = "USDT";
